<template>
    <div class="con">
        <banComponent :img="info.img" :text0="info.text0" :text1="info.text1"></banComponent>

        <div class="main">
            <div class="nav">
                <span v-for="(item,index) in $t('contact').navList" :key="index" :class="{'showLine':select===index}" @click="change(index)">{{item}}</span>
            </div>
        </div>

        <div class="m">
            <transition name="fade">
                <div class="mmp" v-if="select===0">
                    <div class="mainCon" >
                        <p class="title wow fadeInUp">{{$t('contact').text1}}</p>
                        <div class="three wow fadeInUp">
                            <div class="one">
                                <img src="../assets/contact/wz.png" alt="">
                                <span class="a">
                        <span>{{$t('contact').text2}}</span>
                        <span>{{$t('contact').text3}}</span>
                    </span>
                            </div>
                            <div class="one">
                                <img src="../assets/contact/phone.png" alt="">
                                <span class="a">
                        <span>{{$t('contact').text4}}</span>
                        <span>-86-574-87798029</span>
                    </span>
                            </div>
                            <div class="one">
                                <img src="../assets/contact/cz.png" alt="">
                                <span class="a">
                        <span>{{$t('contact').text5}}</span>
                        <span>-86-574-87774225</span>
                    </span>
                            </div>
                        </div>
                    </div>
                    <div class="map">
                        <map-Component></map-Component>
                    </div>
                </div>

            </transition>

            <transition name="fade">
                <div class="m2" v-if="select===1">
                    <p class="title">{{$t('contact').text6}}</p>
                    <div class="send">
                        <input type="text" :placeholder="$t('contact').text7" v-model="form.name">
                        <input type="text" :placeholder="$t('contact').text8" v-model="form.tel">
                        <input type="text" :placeholder="$t('contact').text9" v-model="form.con">
                        <div class="s">
                             <span @click="send">{{$t('contact').text10}}
                                  <i class="iconfont icon-you1"></i></span>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  banComponent from '../components/tbanner'
    import btnComponent from '../components/btn'
    import footComponent from '../components/foot'
    import mapComponent from '../components/bmap'
    import  qs from 'qs'
    export default {
        name: "contact",
        data(){
            return{
                form:{
                    name:'',
                    con:'',
                    tel:''
                },
                select:0,
                navList:[
                    '联系我们',
                    '投诉建议',
                ],
                info:{
                    img:require('../assets/contact/ban.png'),
                    text0:'联系我们',
                    text1:'真情沟通  用心服务'
                }
            }
        },
        components:{banComponent,footComponent,btnComponent,mapComponent},
        mounted(){
            if( this.$i18n.locale === 'en'){
                this.info={
                    img:require('../assets/contact/ban.png'),
                    text0:'CONTACT US',
                    text1:'Truthful communication, attentive service'
                }
            }
        },
        methods:{
            change(n){
                this.select=n
            },
            send(){
                if(this.form.name==='' || this.form.con==='' || this.form.tel===''){
                    this.$notify({
                        title: '提示',
                        message: '请填写完整',
                        offset: 100
                    });
                }else{
                    this.$nextTick(()=>{
                        const url ='/php/form.php'
                        this.$axios.post(url,
                            qs.stringify(
                                this.form
                            )
                        ).then(res => {
                            if(res.status==200)
                            {
                                this.$notify({
                                    title: '成功',
                                    message: '提交成功',
                                    offset: 100
                                })
                                this.form={
                                    email:'',
                                }
                            }else{
                                this.$notify({
                                    title: '失败',
                                    message: '提交失败',
                                    offset: 100
                                });
                            }
                        })
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    .main{
        width:100%;
        .nav{
            width:100%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content:center;
            padding: 1px 0;
            border-bottom: 1px solid rgba(0,0,0,.2);
            span{
                display: inline-block;
                padding: 15px 80px;
                cursor: pointer;
                transition: all 2s;
                font-size: 15px;
            }
            span:hover{
                background-color: #0068B7;
                color:white;
            }
            .showLine{
                background-color: #0068B7;
                color:white;
            }
        }
    }
    .m{
        width:100%;
        .mmp{
            width:100%;
            .mainCon{
                width:1280px;
                margin: 0 auto;
                padding: 60px 0;
                padding-bottom: 60px;
                .title{
                    width:35%;
                    color:#444546;
                    font-size: 30px;
                    font-weight: bold;
                    border-bottom: 1px solid rgba(130, 130, 130, .3);
                    padding-bottom: 20px;
                    position: relative;
                }
                .title::before{
                    position: absolute;
                    left:0;
                    bottom:0;
                    content:'';
                    display: inline-block;
                    width:30%;
                    height:1px;
                    background-color: #0068B7;
                }
                .three{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-top: 60px;
                    .one{
                        display: flex;
                        flex-direction: row;
                        cursor: pointer;
                        img{
                            width:25px;
                            height:22px;
                            object-fit: contain;
                            margin-top: 10px;
                            transition: 1s;
                        }
                        .a{
                            padding-left: 30px;
                            display: flex;
                            flex-direction: column;
                            transition: 1s;
                            span:nth-child(1){
                                font-weight: bold;
                            }
                            span:nth-child(2){
                                font-family: 'normal';
                                font-weight: lighter;
                                padding-top: 10px;
                                font-size: 14px;
                            }
                        }
                    }
                    .one:hover{
                        img,.a{
                            transform: rotate(360deg);
                        }
                        .a{
                            color:#3B95FF;
                        }
                    }
                }
            }
            .map{
                width:100%;
                height:700px;
            }
        }
        .m2{
            width:1280px;
            margin: 0 auto;
            padding: 60px 0;
            .title{
                width:35%;
                color:#444546;
                font-size: 30px;
                font-weight: bold;
                border-bottom: 1px solid rgba(130, 130, 130, .3);
                padding-bottom: 20px;
                position: relative;
            }
            .title::before{
                position: absolute;
                left:0;
                bottom:0;
                content:'';
                display: inline-block;
                width:30%;
                height:1px;
                background-color: #0068B7;
            }
            .send{
                width:1000px;
                margin: 60px auto;
                display: flex;
                flex-direction: column;
                input{
                    border: none;
                    border-bottom: 1px solid #ECECEC;
                    height:35px;
                    margin-top: 60px;
                }
                input:focus{
                    outline: none;
                }
                .s{
                    text-align: right;
                    margin-top: 30px;
                    color:#444546;
                    font-size: 14px;
                    span{
                        padding-right:5px;
                        cursor: pointer;
                        transition: all 2s;
                        i{
                            transition: all 2s;
                        }
                    }
                    span:hover{
                        color:#3B95FF;
                        i{
                            padding-left: 10px;
                            color:#3B95FF;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:1280px){
        .m{
            .mmp{
                .mainCon{
                    width:1200px;
                }
            }
            .m2{
                width:1200px;
            }
        }
    }
    @media screen and (max-width:1279px){
        .main{
            .nav{
                span{
                    width:50%;
                    padding: 15px 0;
                    text-align: center;
                }
            }
        }
        .m{
            .mmp{
                .mainCon{
                    width:90%;
                    margin-left: 5%;
                    padding-bottom: 60px;
                    .title{
                        width:80%;
                    }
                    .three{
                        flex-direction: column;
                        .one{
                            margin-top: 30px;
                            .a{
                                span:nth-child(2){
                                    line-height: 30px;
                                }
                            }
                        }
                        .one:hover{
                            img{
                                transform: rotate(0);
                            }
                            .a{
                                transform: rotate(0);
                            }
                        }
                    }
                }
            }
            .m2{
                width:90%;
                margin-left: 5%;
                .title{
                    width:80%;
                }
                .send{
                    width:100%;
                }
            }
        }
    }
}
</style>